export const SEARCH_QUOTE_RESPONSE = "SEARCH_QUOTE_RESPONSE"

export type QuoteInfo = {
    id: string;
    stateCode: string;
    lineOfBusiness: string[];
    email: string;
    dateOfBirth: string;
    lastName: string;
    zipCode: string;
    phoneNumber: string;
    referenceNumber: string;
    source: string;
    userType: string;
    token: string;
    firstApplicationFormID: string;
    premium: string;
    quoteCreatedDate: string;
    quoteUpdatedDate: string;
    redirectUrl: string;
    firstName: string;
    businessName: string;
    businessAddress: string;
    businessClassDescription: string;
    quoteOutcome?: QuoteOutcome;
    quoteDisclosureDetails?: QuoteDisclosureDetails;
};

export type Notice = {
    noticeType: string;
    messageId: string;
    message: string;
    severity: string;
    sourceProperty: string;
    referringId: string;
    sourceService: string;
};

export type QuoteOutcome = {
    quoteInfoId: number;
    quoteOutcomeType: string;
    primaryOutcomeType: string;
    secondaryOutcomeType: string;
    language: string;
    effectiveDate: string;
    expirationDate: string;
    salesDate: string;
    paymentPlan: string;
    paymentConfirmationNumber: string;
    policyNumber: string;
    soldPremium: string;
    leadSource: string;
    isEndorsement: boolean;
    hasElectronicLoggingDevice?: boolean | null;
    telematicsProgramType?: string | null;
    telematicsSelection?: boolean | null;
};

export type QuoteDisclosureDetails = {
    disclosuresRead: string[];
    disclosuresWithYesSelection: string[];
    disclosuresWithNoSelection: string[];
    disclosuresMarkedAsNotApplicable: string[];
}

export type SearchQuoteResponse = {
    type: typeof SEARCH_QUOTE_RESPONSE;
    data: {
        quoteInfos: QuoteInfo[];
        notices: Notice[];
    };
};